import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { v4 } from 'uuid';
import { logger } from 'common/utils/helpers';
import { useRetrieveDiagnosticPackageMutation } from 'apis/dl';
import { addToastNotification } from 'redux/actions';
import Dialog from 'components/shared/Dialog';
import Button from 'components/shared/Button';
import styles from './DiagnosticPackageRetrieveDialog.module.css';

function DiagnosticPackageRetrieveDialog({ deviceId, onClose, onRetrieve }) {
  const dispatch = useDispatch();
  const { mutateAsync, isLoading } = useRetrieveDiagnosticPackageMutation();
  const retrieve = useCallback(async () => {
    try {
      const result = await mutateAsync({ deviceId });

      onRetrieve(result.diagPkgId);
    } catch (error) {
      logger.error(error);

      dispatch(
        addToastNotification({
          id: v4(),
          title: deviceId,
          description: error?.message ?? 'diagnostic package failed to retrieve.'
        })
      );
    } finally {
      onClose();
    }
  }, [dispatch, mutateAsync, onClose, onRetrieve, deviceId]);

  return (
    <Dialog open={true} onClose={onClose}>
      <Dialog.Container maxWidth={480}>
        <Dialog.Title>
          <h4 className={styles.heading}>Retrieve diagnostic package?</h4>
        </Dialog.Title>
        <Dialog.Content>
          <p className={styles.message}>
            It would take up to <strong>6</strong> minutes.
          </p>
        </Dialog.Content>
        <Dialog.Actions>
          <Button variant="text" color="primary" size="medium" className={styles.cancel} onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="text"
            color="primary"
            size="medium"
            className={styles.retrieve}
            disabled={isLoading}
            onClick={() => {
              retrieve();
            }}
          >
            Run retrieve
          </Button>
        </Dialog.Actions>
        <Dialog.Close />
      </Dialog.Container>
    </Dialog>
  );
}

export default DiagnosticPackageRetrieveDialog;
